import React, { useCallback, useRef, useState } from 'react'

export default function AnimatedCursor({ children, text = 'TODO replace', ...props }) {
    const [height, setHeight] = useState(0)
    const [width, setWidth] = useState(0)

    const [inView, setInView] = useState(false)

    const cursor = useRef(null)

    const animateCursor = useCallback((e) => {
        if (cursor.current !== null) {
            const cursorElement = cursor.current;
            const { x, y } = processEvent(e, { width, height })
            cursorElement.style.transform = `translateY(${y}%) translateX(${x}%)`
        }
    }, [height, width])

    const container = useCallback((el) => {
        if (el !== undefined) {
            setHeight(el?.clientHeight)
            setWidth(el?.clientWidth)
        }
    }, [])

    return (
        <div role='presentation' ref={container} onMouseLeave={() => setInView(false)} onMouseEnter={() => setInView(true)} onMouseMove={animateCursor} className='pos-rel border-box overflow-hidden' {...props}>
            <div ref={cursor} className={'h-100 w-100 pos-abs  cursor-animation  pointer-events-none border-box z-10 ' + (inView ? 'in-view' : 'out-view')}>
                <div className='cursor text-white' >
                    {text}
                </div>
            </div>
            <div className='pointer-events-none z-9'>
                {children}
            </div>
        </div>
    )
}

function processEvent(e, dime) {

    const event = e.nativeEvent
    const { width, height } = dime

    return {
        x: (event.offsetX / width) * 100,
        y: (event.offsetY / height) * 100
    }
}